import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path d='M10.2 8.4C9.21 8.4 8.4 9.21 8.4 10.2V13.8H4.8C3.81 13.8 3 14.61 3 15.6V19.2C3 20.19 3.81 21 4.8 21H19.2C20.19 21 21 20.19 21 19.2V15.6V13.8V10.2V8.4V4.8C21 3.81 20.19 3 19.2 3H15.6C14.61 3 13.8 3.801 13.8 4.8V8.4H10.2ZM8.4 15.6H10.2H19.2V18.3C19.2 18.795 18.795 19.2 18.3 19.2H5.7C5.205 19.2 4.8 18.795 4.8 18.3V16.5C4.8 16.005 5.205 15.6 5.7 15.6H8.4ZM13.8 10.2H15.6H19.2V13.8H10.2V11.1C10.2 10.605 10.605 10.2 11.1 10.2H13.8ZM16.5 4.8H18.3C18.795 4.8 19.2 5.205 19.2 5.7V8.4H15.6V5.7C15.6 5.205 16.005 4.8 16.5 4.8Z' />
        </SvgIcon>
    );
});
